import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty, type FirestoreClickWrap } from '../firestore/ClickWrap/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class ClickWrap extends ObservableModelWithDecorators<FirestoreClickWrap> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreClickWrap>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
